import React, { Component } from "react";
import Button from "../Button";
import TextInput from "../TextInput";
import PropTypes from "prop-types";
import moment from "moment";

class EnrollmentCard extends Component {
    handleTerminate(e) {
        e.preventDefault();

        if (typeof this.props.onTerminate === "function") {
            this.props.onTerminate(e);
        }
    }

    handleSubmit(e) {
        e.preventDefault();

        if (typeof this.props.onSubmit === "function") {
            this.props.onSubmit(e);
        }
    }

    handleUpdate(e) {
        e.preventDefault();

        if (typeof this.props.onSubmit === "function") {
            this.props.onUpdate(e);
        }
    }

    showPdf() {
        this.props.history.push(
            `/dashboard/enroll-confirmation/${this.props.form.id}`
        );
    }

    render() {
        return (
            <div
                className="enrollment-card form-card card z-depth-5"
                ref="form-card"
            >
                <div className="card-content">
                    <span className="card-title">{this.props.title}</span>
                    <form
                        onSubmit={this.handleSubmit.bind(this)}
                        className="left-align"
                        noValidate
                    >
                        <div className="row">
                            <div className="col s6 m6">
                                <TextInput
                                    id={"firstName"}
                                    ref={"firstName"}
                                    label={"Member First Name"}
                                    disabled={true}
                                    type={"text"}
                                    valid={true}
                                    value={this.props.member.firstName}
                                />
                            </div>
                            <div className="col s6 m6">
                                <TextInput
                                    id={"lastName"}
                                    ref={"lastName"}
                                    label={"Member Last Name"}
                                    disabled={true}
                                    type={"text"}
                                    valid={true}
                                    value={this.props.member.lastName}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col s12 m12">
                                <TextInput
                                    id={"nordIdentifier"}
                                    ref={"nordIdentifier"}
                                    label={"Nord Identifier"}
                                    disabled={true}
                                    type={"text"}
                                    valid={true}
                                    value={this.props.member.nordIdentifier}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col s12 m12">
                                <TextInput
                                    className=""
                                    inputClassName=""
                                    label="Award Identifier"
                                    type="text"
                                    value={this.props.awardIdentifier}
                                    valid={this.props.awardIdentifier_valid}
                                    validator={(val) => val.length <= 10}
                                    onChange={this.props.handleChange.bind(
                                        this,
                                        "awardIdentifier"
                                    )}
                                    error="A valid Award Identifier must be less then or equal to 10 characters"
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col s12 m12">
                                <TextInput
                                    id={"coverageEffectiveDate"}
                                    ref={"coverageEffectiveDate"}
                                    label={"Coverage Effective Date"}
                                    type={"date"}
                                    min={moment(
                                        this.props.minEffectiveDate
                                    ).format("YYYY-MM-DD")}
                                    valid={
                                        this.props.coverageEffectiveDate_valid
                                    }
                                    value={this.props.coverageEffectiveDate}
                                    onChange={this.props.handleChange.bind(
                                        this,
                                        "coverageEffectiveDate"
                                    )}
                                />
                            </div>
                        </div>

                        {Object.keys(this.props.form).length === 0 ? (
                            <Button
                                color={"red"}
                                flat={false}
                                onClick={this.handleSubmit.bind(this)}
                                z-depth={1}
                            >
                                Activate Member
                            </Button>
                        ) : (
                            <div className="actions">
                                <Button
                                    className="action-button"
                                    color={"Green"}
                                    flat={false}
                                    onClick={this.handleUpdate.bind(this)}
                                    z-depth={1}
                                >
                                    Update Enrollment
                                </Button>
                                <Button
                                    className="action-button"
                                    color={"red"}
                                    flat={false}
                                    onClick={this.handleTerminate.bind(this)}
                                    z-depth={1}
                                >
                                    Terminate
                                </Button>

                                <Button
                                    className="action-button"
                                    flat={true}
                                    onClick={this.showPdf.bind(this)}
                                    z-depth={1}
                                >
                                    View PDF
                                </Button>

                                {this.props.user.permissions >= 5 && (
                                    <Button
                                        className="action-button resend-record"
                                        flat
                                        onClick={this.props.onResendRecord}
                                        z-depth={1}
                                    >
                                        Resend Record
                                    </Button>
                                )}
                            </div>
                        )}
                    </form>
                </div>
            </div>
        );
    }
}

EnrollmentCard.propTypes = {
    relationshipCode: PropTypes.string,
};
export default EnrollmentCard;



// WEBPACK FOOTER //
// ./src/components/EnrollmentCard/EnrollmentCard.js